
export enum GonvarriCartOutlets{
    GONVARRI_ORDER_SUMMARY = 'gonvarri-cx-order-summary',
    GONVARRI_CART_ITEM_LIST = "app-gonvarri-cart-item-list",
    ITEM_DETAILS = 'cx-cart-item.details',
    ITEM_CONFIGURATOR_ISSUES = 'cx-configurator-issues-notification',
    ITEM_BUNDLE_DETAILS = 'cx-cart-item.bundle-details',
    ITEM_DELIVERY_DETAILS = 'cx-cart-item.delivery-details',
    ORDER_SUMMARY = 'cx-order-summary',
    ADD_TO_CART_CONTAINER = 'cx-add-to-cart-container',
    PICKUP_INFO = 'cx-pickup-info',
    ADD_TO_CART_PICKUP_OPTION = 'cx-add-to-cart-pickup-option',
    DELIVERY_MODE = 'cx-delivery-mode',
    ORDER_OVERVIEW = 'cx-order-overview',
  }
